module.exports = __webpack_public_path__ + "img/RedteaGo 1.b1e60822.png";